import React, { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import API from 'API';
import { Button, Divider, Skeleton, Steps, Tooltip } from 'antd';
import { FileProtectOutlined, RobotOutlined, UserOutlined, WechatOutlined } from '@ant-design/icons';
import SpeechChatBot from '../../EmbedPage/SpeechChatBot';
import ChatBot from '../../EmbedPage/ChatBot';
import { considerStatus, STATUS, STATUS_TEXT } from '../StudentCalendar/TestModal';
import dayjs from 'dayjs';
import { formatScore } from 'general_function';
import { theme } from 'antd';
import { NotFound } from 'AppRoute';
import { testTypeOptions } from 'components/pages/UniversitySide/UniversityTest';
import { getScoreColor } from '../StudentCalendar/style_const';
import TermHandle from 'components/pages/UniversitySide/UniversityTerms/TermHandle';
import PathTabs from 'components/general/PathTabs';
import StudentLesson from '../StudentLesson';
const { useToken } = theme;

const NOW = dayjs();

const testColor = "rgb(35, 0, 192)";

function TestCell({ test, week, currentWeek }) {
    const status = considerStatus(test, NOW);
    const status_text = STATUS[status];
    const navigate = useNavigate();
    return <>
        <Divider style={{ marginBottom: 3, marginTop: 3 }}/>
        <Tooltip title={
            <div key={test.release} className={`date-cell-event ${status_text}`} style={{
                paddingLeft: 10, boxShadow: "0 2px 2px rgba(0, 0, 0, 0.15)", backgroundColor: "white", marginBottom: 10,
                cursor: "auto", color: "black"
            }}>
                <div>
                    <b>Tiêu đề:</b> {test.title}
                </div>
                <div>
                    <b>Cách tính điểm:</b> {testTypeOptions.find(item => item.value === test.type).label}
                </div>
                <div>
                    <b>Điểm số:</b> <span style={{
                        color: getScoreColor(test.result)
                    }}>{formatScore(test.result, test.end_time, true)}</span>
                </div>
                <div style={{ color: "rgb(102 102 102)", fontSize: 12, fontWeight: "bold" }}>
                    {test.start_time.format("DD/MM/YYYY HH:mm:ss")} - {test.end_time.format("DD/MM/YYYY HH:mm:ss")}
                </div>
                <div style={{ color: "rgb(102 102 102)", fontSize: 12, fontWeight: "bold" }}>
                    Số lần làm bài: {test.done}/{test.limit}<br />
                </div>
                <div>
                    <span className={`test-status ${STATUS[status]}`}>
                        {STATUS_TEXT[status]}
                    </span>
                </div>
                <div>
                    <Button type='link' onClick={() => navigate(`/student-test/${test.release}`)}>
                        {status === 1 ? "Vào làm bài" : "Xem chi tiết"}
                    </Button>
                </div>
            </div>
        } color='white'>
            <div style={{ cursor: "pointer", color: testColor, whiteSpace: week !== currentWeek ? "normal" : null, paddingRight: 14 }}>
                <FileProtectOutlined /> {test.title}
                {test.result !== null && <>: <span style={{ color: getScoreColor(test.result) }}>
                    {formatScore(test.result)}
                </span></>}
            </div>
        </Tooltip>
    </>
}

export default function StudentCourse() {
    const { id } = useParams();
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openChatBot, setOpenChatBot] = useState(false);
    const [openLanguageChatBot, setOpenLanguageChatBot] = useState(false);
    const [terms, setTerms] = useState(null);
    const [selectedTerm, setSelecterdTerm] = useState(null);
    const { token } = useToken();

    useEffect(() => {
        setCourse(null);
        setLoading(true);
        API.get(`student/courses/${id}/`)
            .then(res => {
                var check = false;
                for (const r of res.data.terms) {
                    r.start_time = dayjs(r.start_time);
                    r.end_time = dayjs(r.end_time);
                    r.start_week = dayjs(r.start_week);
                    if (!check) {
                        if (r.start_time.isBefore(NOW) && r.end_time.isAfter(NOW)) {
                            check = true;
                            setSelecterdTerm(r);
                        }
                    }
                    if (r.course_terms[0] && r.course_terms[0].final_exam_time) {
                        r.course_terms[0].final_exam_time = dayjs(r.course_terms[0].final_exam_time);
                    }
                }
                if (!check) {
                    setSelecterdTerm(res.data.terms[0] || null);
                }
                for (const r of res.data.tests) {
                    r.start_time = dayjs(r.start_time);
                    r.end_time = dayjs(r.end_time);
                }
                setCourse(res.data);
                setTerms(res.data.terms);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(()=>{
                setLoading(false);
            })
    }, [id])

    useEffect(() => {
        if (!course) return;
        document.title = course.name;
    },[course])

    const currentWeek = useMemo(() => 
        selectedTerm ? Math.floor(NOW.diff(selectedTerm.start_week, 'day')/7) : 0,
    [selectedTerm])

    const examWeek = useMemo(() => {
        if (!selectedTerm || !selectedTerm.course_terms[0] || !selectedTerm.course_terms[0].final_exam_time) return -1;
        return Math.floor(selectedTerm.course_terms[0].final_exam_time.diff(selectedTerm.start_week, "day")/7);
    },[selectedTerm])

    const lessonWeek = useMemo(() => {
        if (!course) return [];
        return course.lessons.map((item, index) => {
            const start_week = selectedTerm.start_week.add(index*7, "day");
            const end_week = selectedTerm.start_week.add((index + 1)*7, "day");
            return {
                title: `Tuần ${index+1}`,
                description: <>
                    {selectedTerm.start_week.add(7 * index, "day").format("DD/MM/YYYY")} <br />
                    {item.name} <br />
                    {course.tests.map(test => 
                    test.start_time.isAfter(start_week) && test.start_time.isBefore(end_week)
                    && <TestCell test={test} week={index} key={test.id} currentWeek={currentWeek}/>)}
                </>
            }
        })
    },[course, selectedTerm, currentWeek])

    const extraWeek = useMemo(() => {
        if (!course) return [];
        return Array.from({ length: examWeek - course.lessons.length + 1 }, (_, i) =>
            i + course.lessons.length).map((item, index) => ({
                title: `Tuần ${item+1}`,
                description: <>
                    {selectedTerm.start_week.add(7 * item, "day").format("DD/MM/YYYY")} <br />
                    {index === examWeek - course.lessons.length
                    && <>
                        <Divider style={{ marginBottom: 3, marginTop: 3 }}/>
                        <div style={{ color: testColor, whiteSpace: currentWeek !== item ? "normal" : null }}>
                            <FileProtectOutlined /> Thi: {selectedTerm.course_terms[0].final_exam_time.format("DD/MM/YYYY HH:mm:ss")}
                        </div>
                    </>}
                </>
            }));
    },[selectedTerm, examWeek, course, currentWeek])

    const weekList = useMemo(() => [...lessonWeek, ...extraWeek], [lessonWeek, extraWeek]);

    return loading ? <Skeleton active /> : !course ? <NotFound /> : <>
        <TermHandle terms={terms} setTerms={setTerms} edit={false}
            selectedTerm={selectedTerm} setSelecterdTerm={setSelecterdTerm} />
        <h4>{course.name}</h4>
        <div>
            <b>Giảng viên phụ trách:</b>
                {course.teachers.map((item, index) => <Link to={`/users/${item.id}`} key={item.id} style={{
                    display: "inline-block",
                    marginLeft: 5
                }}>
                    <UserOutlined /> {item.last_name} {item.first_name}{(index !==  course.teachers.length - 1) && ", "}
                </Link>)}
        </div>
        <p>{course.description}</p>
        
        <div>
            <b>Môn họn tiên quyết: </b>
            {course.required_courses.length === 0 ? <>Không có</>
            : course.required_courses.map(item => <Link key={item.id} to={`/student-courses/${item.id}`}>
                <div style={{
                    backgroundColor: token.colorPrimary, color: "white",
                    padding: "3px 7px", display: "inline-block", margin: 3,
                    borderRadius: 3
                }}>
                    {item.name}
                </div></Link>)}
        </div>

        <Divider orientation="left">Danh sách bài học</Divider>

        <Steps
            current={currentWeek}
            items={weekList}
        />

        <PathTabs 
            basePath={`/student-courses/${id}`}
            titlePath={course.name}
            items={course.lessons.map((lesson, index) => ({
                label: `Tuần ${index+1}`,
                key: `lesson/${lesson.id}`,
                children: <StudentLesson id={lesson.id}/>
            }))}
            defaultKey={currentWeek < course.lessons.length ? `lesson/${course.lessons[currentWeek].id}` : null}
        />

        <Button type="primary" onClick={() => setOpenChatBot(!openChatBot)} style={{
            position: "fixed", bottom: 15, right: 15,
            transition: "opacity 0.3s ease, transform 0.3s ease",
            opacity: !openChatBot ? 1 : 0,
            transform: !openChatBot ? "translateY(0)" : "translateY(20px)",
        }}>
            <RobotOutlined />
        </Button>
        <div style={{
            height: 570, maxHeight: "calc(100vh - 30px)",
            width: 500, maxWidth: "calc(100vw - 15px)",
            position: "fixed", bottom: 15, right: 10,
            transition: "opacity 0.3s ease, transform 0.3s ease",
            opacity: openChatBot ? 1 : 0,
            transform: openChatBot ? "translateY(0)" : "translateY(20px)",
            pointerEvents: openChatBot ? "auto" : "none",
            zIndex: 10000,
        }}>
            <ChatBot course_id={course.id} setClose={() => setOpenChatBot(false)} />
        </div>

        {course.language && <><Button type="primary" onClick={() => setOpenLanguageChatBot(!openChatBot)} style={{
            position: "fixed", bottom: 50, right: 15,
            transition: "opacity 0.3s ease, transform 0.3s ease",
            opacity: !openLanguageChatBot ? 1 : 0,
            transform: !openLanguageChatBot ? "translateY(0)" : "translateY(20px)",
        }}>
            <WechatOutlined />
        </Button>
            <div style={{
                height: 570, maxHeight: "calc(100vh - 30px)",
                width: 500, maxWidth: "calc(100vw - 15px)",
                position: "fixed", bottom: 15, right: 10,
                transition: "opacity 0.3s ease, transform 0.3s ease",
                opacity: openLanguageChatBot ? 1 : 0,
                transform: openLanguageChatBot ? "translateY(0)" : "translateY(20px)",
                pointerEvents: openLanguageChatBot ? "auto" : "none",
                zIndex: 10000,
            }}>
                <SpeechChatBot course_id={course.id} setClose={() => setOpenLanguageChatBot(false)} />
            </div></>}
    </>
}
